import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { UserDebt } from 'Douleutaras/types/index';
import { makeRequest } from 'Douleutaras/services/apiClient';

export const createUserDebtEndpoint = (userId: number) => `api/public/user/${userId}/debt_indicator`;

export const fetchUserDebt = createAsyncThunk('user/debt/get', async (userId: number, api) => {
  const response = await makeRequest(createUserDebtEndpoint(userId), {})(api);

  return response.data;
});

const userDebtSlice = createSlice({
  name: 'userDebt',
  initialState: {} as UserDebt,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchUserDebt.fulfilled, (state, action) => {
      return { ...action.payload, loading: false };
    });
    builder.addCase(fetchUserDebt.pending, (state, action) => {
      return { ...state, loading: true };
    });
    builder.addCase(fetchUserDebt.rejected, (state, action) => {
      return { ...state, loading: false };
    });
  }
});

export default userDebtSlice;
